// This module provides API call methods for Sephora Commerce CMS API:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Sephora+Commerce+CMS+API+Specification

import getMediaContentApi from 'services/api/cms/getMediaContent';

const { getMediaContent, getMediaContentByScreen, getRwdMediaContent } = getMediaContentApi;

export default {
    getMediaContent,
    getMediaContentByScreen,
    getRwdMediaContent
};
